import React from 'react';
import AddElement from './AddElement';

interface AddWebsiteProps {
  onClick: () => void;
}
const AddWebsite: React.FC<AddWebsiteProps> = ({ onClick }) => (
  <AddElement label="Website" onClick={onClick} />
);

export default AddWebsite;
